function excelDateToJS(excelSerial) {
  // Excel epoch is Jan 1, 1900. Unix epoch is Jan 1, 1970.
  // The difference is 25569 days.
  // Multiply by 86400 (seconds in a day) and 1000 to get milliseconds.

  var dt = new Date(Math.round((excelSerial - 25569) * 86400 * 1000));

  dt.setDate(dt.getDate() + 1); // Add 1 days

  return dt;
}

export default function formatDateFld(date) {
  if (date === undefined) {
    return date;
  } else if (date instanceof Date) {
    return date;
  } else if (Number.isInteger(parseInt(date))) {
    var excelDate = excelDateToJS(parseInt(date));
    return excelDate;
  } else if (typeof date === "string") {
    const parsedDate = Date.parse(date);
    if (!isNaN(parsedDate)) {
      return new Date(parsedDate);
    } else {
      console.warn(`Unable to parse date string: ${date}`);
      return date;
    }
  } else {
    console.warn(`Unexpected date format: ${date}`);
    return date;
  }
}
